/**
 * The other corner: the main menu, hidden inside a tool with the rest of the
 * app-level layer (see .top-left.in-tool).
 */

import { useOpenTool } from '../state/hooks'
import { MainMenuControl } from './MainMenuControl'

export function TopLeftCluster() {
  const inTool = useOpenTool() !== null
  return (
    <div className={'top-left' + (inTool ? ' in-tool' : '')}>
      <MainMenuControl />
    </div>
  )
}
